"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBuilderHints = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importStar(require("react"));
const runtime_1 = require("@grafana/runtime");
const ui_1 = require("@grafana/ui");
const QueryBuilderHints = ({ datasource, query: visualQuery, onChange, data, queryModeller, buildVisualQueryFromString, buildDataQueryFromQueryString, buildQueryStringFromDataQuery, }) => {
    const [hints, setHints] = (0, react_1.useState)([]);
    const styles = (0, ui_1.useStyles2)(getStyles);
    (0, react_1.useEffect)(() => {
        var _a;
        const dataQuery = buildDataQueryFromQueryString(queryModeller.renderQuery(visualQuery));
        // For now show only actionable hints
        const hints = (_a = datasource.getQueryHints) === null || _a === void 0 ? void 0 : _a.call(datasource, dataQuery, (data === null || data === void 0 ? void 0 : data.series) || []).filter((hint) => { var _a; return (_a = hint.fix) === null || _a === void 0 ? void 0 : _a.action; });
        setHints(hints !== null && hints !== void 0 ? hints : []);
    }, [datasource, visualQuery, data, queryModeller, buildDataQueryFromQueryString]);
    return (react_1.default.createElement(react_1.default.Fragment, null, hints.length > 0 && (react_1.default.createElement("div", { className: styles.container }, hints.map((hint) => {
        var _a, _b, _c, _d;
        return (react_1.default.createElement(ui_1.Tooltip, { content: `${hint.label} ${(_a = hint.fix) === null || _a === void 0 ? void 0 : _a.label}`, key: hint.type },
            react_1.default.createElement(ui_1.Button, { onClick: () => {
                    var _a, _b, _c;
                    (0, runtime_1.reportInteraction)('grafana_query_builder_hints_clicked', {
                        hint: hint.type,
                        datasourceType: datasource.type,
                    });
                    if ((_a = hint === null || hint === void 0 ? void 0 : hint.fix) === null || _a === void 0 ? void 0 : _a.action) {
                        const dataQuery = buildDataQueryFromQueryString(queryModeller.renderQuery(visualQuery));
                        const newQuery = (_b = datasource.modifyQuery) === null || _b === void 0 ? void 0 : _b.call(datasource, dataQuery, hint.fix.action);
                        if (newQuery) {
                            const newVisualQuery = buildVisualQueryFromString((_c = buildQueryStringFromDataQuery(newQuery)) !== null && _c !== void 0 ? _c : '');
                            return onChange(newVisualQuery.query);
                        }
                    }
                }, fill: "outline", size: "sm", className: styles.hint },
                "hint: ",
                ((_b = hint.fix) === null || _b === void 0 ? void 0 : _b.title) || ((_d = (_c = hint.fix) === null || _c === void 0 ? void 0 : _c.action) === null || _d === void 0 ? void 0 : _d.type.toLowerCase().replace('_', ' ')))));
    })))));
};
exports.QueryBuilderHints = QueryBuilderHints;
exports.QueryBuilderHints.displayName = 'QueryBuilderHints';
const getStyles = (theme) => {
    return {
        container: (0, css_1.css) `
      display: flex;
      align-items: start;
    `,
        hint: (0, css_1.css) `
      margin-right: ${theme.spacing(1)};
    `,
    };
};
//# sourceMappingURL=QueryBuilderHints.js.map